import AnswerFactory from '../answer_factory'
// TODO: extract form_validator to a shared folder
import FormValidator from '../applied_form/validators/form_validator'
import FormValueGetter from '../applied_form/form_value_getter'
import { Toast } from 'bootstrap'

document.addEventListener("turbolinks:load", function () {

  // todo: dont fix on first, get last answered form session.
  renderFirstFormSession()

  if (isAppliedFormView()) {

    // todo: send only questions of the current session.
    // todo: review continue form
    // document.getElementById('btn-save-self-applied-form').addEventListener('click', (event) => {
    document.querySelectorAll('.btn-save-self-applied-form').forEach(saveButton => {
      saveButton.addEventListener('click', (event) => {
        event.preventDefault()
        const questionCards = document.querySelectorAll('.question')
        const validQuestions = Array.from(questionCards).filter(card => {
          const value = new FormValueGetter(card).getValue()
          const invalidValues = [undefined, null, '']
          return invalidValues.includes(value) === false && JSON.stringify(value) != JSON.stringify({value: null, complementaryValue: ''}) && JSON.stringify(value) != JSON.stringify({value: [], complementaryValue: ''})
        })

        if (new FormValidator().isValid()){
          const answers = Array.from(validQuestions).map(questionCard => {
            return new AnswerFactory(questionCard).build()
          })
          const authToken = document.getElementsByTagName('meta')[2].content
          const headers = { 'X-CSRF-Token': authToken }
          const selfAppliedFormId = document.getElementById('self-applied-form-id').value
          const body = { answers, self_applied_form_id: selfAppliedFormId, status: 'progress' }
          axios.post('/saas/self_applied_forms/answers', body, { headers })
            .then(_response => {
              renderNextFormSession()
              var myToastEl = document.getElementById('toast')
              var myToast = new Toast(myToastEl, {})
              myToast.show()
            })
            .catch(error => console.log(error))
        }
      })
    })

    document.querySelectorAll('.btn-previous-form-session').forEach(saveButton => {
      saveButton.addEventListener('click', (event) => {
        event.preventDefault()
        const currentFormSessionField = document.getElementById('current-form-session')
        const newSession = parseInt(currentFormSessionField.value) - 1
        const currentFormSession = parseInt(currentFormSessionField.value)
        currentFormSessionField.value = newSession
        const currentFormSessionTag = document.querySelector(`[data-form-session-sequence='${currentFormSession}']`)
        currentFormSessionTag.setAttribute('hidden', 'true')
        const nextFormSessionTag = document.querySelector(`[data-form-session-sequence='${newSession}']`)
        nextFormSessionTag.removeAttribute('hidden')
      })
    })

    // note: finish form
    document.querySelectorAll("#btn-save-and-finish-self-applied-form").forEach(saveFinish => {
      saveFinish.addEventListener('click', (event) => {
        event.preventDefault()
        const questionCards = document.querySelectorAll('.question')
        let validQuestions = Array.from(questionCards).filter(card => {
          const value = new FormValueGetter(card).getValue()
          const invalidValues = [undefined, null, '']
          return invalidValues.includes(value) === false && JSON.stringify(value) != JSON.stringify({value: null, complementaryValue: ''}) && JSON.stringify(value) != JSON.stringify({value: [], complementaryValue: ''})
        })

        if (new FormValidator().isValid()){
          if (hasEliminatoryAnswer(validQuestions)) {
            validQuestions = Array.from(validQuestions).filter(questionCard => {
              if (new AnswerFactory(questionCard).questionKind === 'boolean_eliminatory_form') {
                return questionCard
              }
            })
          }

          const answers = Array.from(validQuestions).map(questionCard => {
            return new AnswerFactory(questionCard).build()
          })

          const authToken = document.getElementsByTagName('meta')[2].content
          const headers = { 'X-CSRF-Token': authToken }
          const selfAppliedFormId = document.getElementById('self-applied-form-id').value
          const body = { answers, self_applied_form_id: selfAppliedFormId, status: 'finished', reset: hasEliminatoryAnswer(validQuestions) }
          axios.post('/saas/self_applied_forms/answers', body, { headers })
          .then(response => {
              var myToastEl = document.getElementById('toast')
              var myToast = new Toast(myToastEl, {})
              myToast.show()
              const currentUrl = window.location.href
              const baseUrl = currentUrl.split('/self_applied_forms')[0]
              window.location.replace(`${baseUrl}/self_applied_forms/finish/${selfAppliedFormId}`)
            })
            .catch(error => console.log(error))
        }
      })
    })
  }
})

function isAppliedFormView() {
  return document.getElementById('form-self-applied-answers')?.length > 0
}

function renderFirstFormSession() {
  const formSessions = document.querySelectorAll('.form-session')
  const firstFormSession = formSessions[0]
  firstFormSession.removeAttribute('hidden')
  const currentFormSession = document.getElementById('current-form-session')
  currentFormSession.value = 1
}

function hasEliminatoryAnswer(questions) {
  return questions.some((question) => {
    const answer = new AnswerFactory(question)
    return answer.questionKind == 'boolean_eliminatory_form' && answer.value == 'Não'
  })
}

function renderNextFormSession() {
  const formSessions = Array.from(document.querySelectorAll('.form-session'))
  const currentFormSessionField = document.getElementById('current-form-session')
  const currentFormSession = parseInt(currentFormSessionField.value)
  if (currentFormSession == formSessions.length) {
    // todo: handle implementation
    console.log('Last session.')
  } else {
    const nextFormSession = currentFormSession + 1
    const currentFormSessionTag = document.querySelector(`[data-form-session-sequence='${currentFormSession}']`)
    currentFormSessionTag.setAttribute('hidden', 'true')
    const nextFormSessionTag = document.querySelector(`[data-form-session-sequence='${nextFormSession}']`)
    nextFormSessionTag.removeAttribute('hidden')
    currentFormSessionField.value = nextFormSession
  }
}
